import { cn } from '@/utils/cn';

export function OutOfBudgetBoostSwitch({
  enabled,
  disabled,
  onClick,
}: {
  enabled: boolean;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label="Out of budget budget increase"
      title="Increase budget when out of budget"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 align-middle rounded-full transition-colors',
        enabled ? 'bg-brand' : 'bg-border',
        disabled && 'cursor-not-allowed opacity-50'
      )}
    >
      <span
        className={cn(
          'absolute top-0.5 left-0.5 h-4 w-4 rounded-full bg-surface shadow transition-transform',
          enabled && 'translate-x-4'
        )}
      />
    </button>
  );
}
